import { App } from '@capacitor/app';
import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { NavigationPath, useNavigateWithSnapshots } from 'context';
import { usePlatform } from 'hooks';

export const useAndroidBackButton = (backPath?: NavigationPath) => {
  const { isAndroid } = usePlatform();
  const navigate = useNavigateWithSnapshots();
  const location = useLocation();

  const handleBackButton = useCallback(() => {
    if (typeof backPath === 'string') {
      navigate(backPath, 'backward');
    } else if (backPath === -1 || backPath === 0) {
      navigate(backPath, 'backward');
    } else if (
      location.key !== 'default' &&
      location.pathname !== '/' &&
      location.pathname !== '/home' && // Sometimes key changes even though we're at home
      location.pathname !== '/login'
    ) {
      navigate(-1, 'backward');
    } else {
      void App.exitApp();
    }
  }, [backPath, navigate, location]);

  const setupBackButtonListener = useCallback(async () => {
    const backButtonListener = await App.addListener(
      'backButton',
      handleBackButton
    );

    // Cleanup
    return () => {
      void backButtonListener.remove();
    };
  }, [handleBackButton]);

  useEffect(() => {
    if (!isAndroid) {
      return;
    }

    const listenerPromise = setupBackButtonListener();

    return () => {
      // This handles the promise when cleanup is needed
      void listenerPromise.then((cleanupFn) => {
        if (cleanupFn) cleanupFn();
      });
    };
  }, [setupBackButtonListener, isAndroid]);
};
